import { User } from '@models/user.model';
import { ApplicationPathType } from '@modules/test-development/enums/application-path-type.enum';
import { Platform, ApplicationType } from '@testsigmainc/constants';
import { TestPlanLabType } from '@modules/test-development/enums/test-plan-lab-type.enum';
import { Capability } from '@modules/test-development/models/capability.model';
import { Base } from '@testsigmainc/models';
import { PageObject } from '@testsigmainc/models';
import {
  SKIP,
  alias,
  custom,
  deserialize,
  object,
  optional,
  primitive,
  serializable,
} from 'serializr';
import { MobileInspectionStatus } from '../enums/mobile-inspection-status.enum';
import { MobileInspectionSavedConfiguration } from '@modules/test-development/models/mobile-inspection-saved-configuration.model';
import { IosWdaDetails } from '@modules/test-development/models/ios-wda-details.model';

export class MobileInspection extends Base implements PageObject {
  @serializable(primitive())
  userId: number;
  @serializable(primitive())
  stoppedUserId: number;
  @serializable(primitive())
  platform: Platform;
  @serializable(primitive())
  agentDeviceId: number;
  @serializable(primitive())
  agentId: number;
  @serializable(primitive())
  status: MobileInspectionStatus;
  @serializable(primitive())
  executionLabType: TestPlanLabType;
  @serializable(primitive())
  platformDeviceId: number;
  @serializable(primitive())
  appActivity: string;
  @serializable(primitive())
  bundleId: string;
  @serializable(primitive())
  appUploadId: number;
  @serializable(primitive())
  uploadVersionId: number;
  @serializable(primitive())
  appUrl: string;
  @serializable(optional(object(User)))
  public stoppedUser: User;
  @serializable(primitive())
  sessionId: string;
  @serializable(primitive())
  applicationPackage: string;
  @serializable(primitive())
  agentHostname: string;
  @serializable(primitive())
  applicationPathType: ApplicationPathType;
  @serializable(
    alias(
      'STARTED_AT',
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public startedAt: Date;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public timeToLoadFirstScreen: Date;

  @serializable(optional(primitive()))
  recordClickInitiatedAt: number;
  @serializable(
    alias(
      'FINISHED_AT',
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public finishedAt: Date;
  @serializable(
    alias(
      'LAST_ACTIVE_AT',
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public lastActiveAt: Date;
  @serializable(
    alias(
      'createdAtEpoch',
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public createdAtEpoch: Date;
  @serializable(
    alias(
      'updatedAtEpoch',
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public updatedAtEpoch: Date;
  @serializable(primitive())
  jwtApiKey: string;

  @serializable(primitive())
  testsigmaLabType: string;

  @serializable(primitive())
  uniqueId: string;

  @serializable(
    custom(
      (v) => {
        const arr = [];
        if (v) {
          if (!(v instanceof Array)) {
            v = JSON.parse(v);
          }
          v.forEach((capability) => {
            const key = Object.keys(capability);
            if (
              capability[key[0]]?.length &&
              capability[key[1]]?.length &&
              capability[key[2]]?.length
            ) {
              arr.push(new Capability().deserialize(capability));
            }
          });
        }
        return JSON.stringify(arr);
      },
      (v) => {
        const capabilities = [];
        if (typeof v == 'string') {
          if (/\\\\"/g.test(v)) {
            v = v.replace(/\\"/g, '"');
            v = v.replace(/\\"/g, '"');
          } else if (v.startsWith('[{\\"')) {
            v = v.replace(/\\"/g, '"');
          }
          v = JSON.parse(v);
          v.forEach((capability) => {
            capabilities.push(new Capability().deserialize(capability));
          });
        } else if (v instanceof Object)
          v.forEach((capability) => {
            capabilities.push(new Capability().deserialize(capability));
          });
        return capabilities;
      },
    ),
  )
  public capabilities: Capability[];

  @serializable
  public testCaseResultId: number;

  @serializable
  public isRealDevice: boolean;

  @serializable
  public isCameraImageInjectionEnabled: boolean;

  @serializable
  public isNetworkLogsEnabled: boolean;

  @serializable
  public isTouchIdEnrolled: boolean;

  //presention / from db
  @serializable(optional(object(User)))
  public executedBy: User;

  @serializable
  public appType: ApplicationType;

  @serializable(optional(object(MobileInspectionSavedConfiguration)))
  public lastUsedConfig: MobileInspectionSavedConfiguration;

  @serializable(optional(object(IosWdaDetails)))
  public iosWdaDetails: IosWdaDetails;

  @serializable
  public lastUsedSavedConfigId: number;

  @serializable
  public isLastUsedSavedConfigChanged: boolean;

  @serializable
  public testCaseId: number;

  public platformDeviceName;
  public platformOsName;
  public platformOsVersion;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(MobileInspection, input));
  }
}
